import React, { useState } from 'react';
import { Button, Modal, Box, TextField, Typography } from '@mui/material';
import { fetchWithToken } from "../api/apiutils";

const BanListAdd = ({ onAdd }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setName('');
    setUrl('');
  };

  const handleAdd = () => {
    const newItem = {
      name: { ru: name },
      url
    };

    fetchWithToken('/api/banList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newItem)
    })
    .then(response => {
      if (response.ok) {
        response.json().then(data => {
          onAdd(data);
          handleClose();
        });
      } else {
        console.error('Ошибка при добавлении:', response.statusText);
      }
    })
    .catch(error => console.error('Ошибка при добавлении:', error));
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Создать
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            p: 4,
            borderRadius: 2,
            boxShadow: 3,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2">
            Добавить новый элемент
          </Typography>
          <TextField
            label="Наименование"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="URL"
            fullWidth
            margin="normal"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAdd}
            sx={{ mt: 2 }}
          >
            Добавить
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default BanListAdd;
